module.exports = __webpack_public_path__ + "static/media/SectionTwoImg.61b962c5.webp";